import React from 'react'
import { useTranslation } from 'next-i18next'
// eslint-disable-next-line import/order
import styled from 'styled-components'
import { useRouter } from 'next/router'

import { Modal, Props as ModalProps } from './Modal'
import { show, showFinally } from '../../utils'
import { H5, P } from '../Headings'
import { ModalContentWrapper } from './ModalContentWrapper'
import { ModalCloseButton } from './ModalCloseButton'
import { CTA } from '../CTA'
import { FormField } from '../Inputs/FormField'
import { Input } from '../Inputs/Input'
// eslint-disable-next-line import/order
import { EmailRsvpHock } from '../../hooks/emailRsvp'

// Styles
import { emailRSVPEventModalStyles } from './emailRSVPEventModalStyles'

const EventModalContentContainer = styled(ModalContentWrapper)`
  ${emailRSVPEventModalStyles}
`

interface Props extends ModalProps {
  onClose?: () => void
  onSubmited?: () => void
  emailRsvpHock: EmailRsvpHock
}

export const EmailRSVPEventModal: React.FC<Props> = (props) => {
  const router = useRouter()
  const { t } = useTranslation('common')

  // Props.
  const { onClose, onSubmited, emailRsvpHock } = props

  // Global State
  const { name, email, setName, setEmail, errors, isLoading } = emailRsvpHock

  // Funcs
  const theOnClose = () => {
    if (onClose) {
      onClose()
    } else {
      console.warn('@EmailRSVPEventModal->onClose: func not set')
    }
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmited()
  }

  const goToLogin = () =>
    void router.push(`/login?redirect=/events/${router.query.event}`)

  // ..
  return (
    <Modal close={theOnClose}>
      <EventModalContentContainer>
        <ModalCloseButton onClick={theOnClose} />
        <form onSubmit={onSubmit}>
          {/* Text */}
          <H5 className="header">
            {t(`Register for event`, `Register for event`)}
          </H5>
          <P>
            {t(
              `EmailRSVPEventModal1803740483`,
              `Receive email reminders and updates relating to the event.`,
            )}
          </P>

          {/* Inputs */}
          <FormField title={t(`Name`, `Name`)} required error={errors?.name}>
            <Input
              placeholder={t(`Your Name`, `Your Name`)}
              value={name}
              onChange={setName}
            />
          </FormField>

          <FormField title={t(`Email`, `Email`)} required error={errors?.email}>
            <Input
              placeholder={t(`your@email.com`, `your@email.com`)}
              value={email}
              onChange={setEmail}
            />
          </FormField>

          <div className="actions">
            {/* Login button */}
            <CTA onClick={goToLogin} className="login">
              {t(`Log in`, `Log in`)}
            </CTA>

            {/* Submit through form */}
            <CTA type="submit" className="submit purple" disabled={isLoading}>
              {show(isLoading !== true) && (
                <>
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img src="/icons/calendar-white.svg" alt="" />{' '}
                  {t(`Register`, `Register`)}
                </>
              )}
              {showFinally(isLoading === true) && (
                <>{t(`Please wait`, `Please wait`)}</>
              )}
            </CTA>
          </div>

          {/* Any other errors */}
          <P className="warning server-error-message">
            {errors?.t_zone || errors?.error}
          </P>
        </form>
      </EventModalContentContainer>
    </Modal>
  )
}
